'use client'

import posthog from 'posthog-js'
import NextError from 'next/error'
import { useEffect } from 'react'

export default function GlobalError({ error, reset }: any) {
  useEffect(() => {
    posthog.captureException(error)
  }, [error])

  return (
    // global-error must include html and body tags
    <html>
      <body>
        {/* `NextError` is the default Next.js error page component */}
        <NextError statusCode={0} />
      </body>
    </html>
  )
}
